import { render, staticRenderFns } from "./makeHole.vue?vue&type=template&id=7471c010&scoped=true"
import script from "./makeHole.vue?vue&type=script&lang=js"
export * from "./makeHole.vue?vue&type=script&lang=js"
import style0 from "./makeHole.vue?vue&type=style&index=0&id=7471c010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7471c010",
  null
  
)

export default component.exports